module.exports = function filterManagerMaker() {
  class FilterManager {
    constructor(data) {
      this._listeners = [];
      this._filters = {};
      this._queryListeners = [];
      this._queries = {};
      this._sort = [['_id', -1]];
      this._data = data;
      this._filteredData = data;
    }

    dataChanged(data) {
      if (data) {
        this._data = data;
      }

      this.doFilter();
    }

    // setSort(sortOptions) {
    //   this._sort = sortOptions.map((o) => o.field ? [o.field, o.direction || 'asc'] : o)
    //   this._notifyQueryChanged();
    // }
    //
    setSort(sortOptions) {
      this._sort = sortOptions.map(o => ({[o.field]: o.direction})).reduce((a, b) => ({...a, ...b}), {})
      this._notifyQueryChanged();
    }

    _notify(data) {
      this._listeners.forEach((listener) => listener(data))
    }

    _notifyQueryChanged() {
      this._queryListeners.forEach((listener) => listener({queries: this.getQueries(), sort: this.getSort()}))
    }

    getData() {
      return this._data;
    }

    addListener(listener) {
      this._listeners.push(listener)
      listener(this._filteredData);
    }

    addQueryListener(listener) {
      this._queryListeners.push(listener);
    }

    setFilter(name, predicate, query) {
      if (!predicate) {
        delete this._filters[name];
        if (this._queries.hasOwnProperty(name)) {
          delete this._queries[name];
          this._notifyQueryChanged();
        }
      } else {
        this._filters[name] = predicate;

        if (query) {
          this._queries[name] = query
          this._notifyQueryChanged();
        }
      }

      this.doFilter();
    }

    getQueries() {
      return Object.values(this._queries);
    }

    getSort() {
      return this._sort
    }

    doFilter() {
      this._filteredData = this._applyFilters();

      this._notify(this._filteredData);
    }

    _applyFilters() {
      let filteredData = this._data;

      Object.keys(this._filters).forEach((name) => {
        filteredData = filteredData.filter((d) => {
          return this._filters[name](d)
        });
      });

      return filteredData;
    }
  }

  function debounce(func, wait, immediate) {
    let timeout;

    return function () {
      let context = this
      let args = arguments;
      let later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  FilterManager.prototype._notifyQueryChanged = debounce(FilterManager.prototype._notifyQueryChanged, 250);

  return {
    createFilterManager: (data) => new FilterManager(data.slice())
  };
}
